import React from 'react';
const bonuses = [{
  num: 1,
  title: 'Tabla Maestra de Neutralización',
  desc: 'Guía visual de consulta rápida para neutralización inmediata.',
  price: '$8.000 ARS'
}, {
  num: 2,
  title: 'Biblioteca de Fórmulas Profesionales Adaptables',
  desc: 'Casos prácticos y fórmulas referenciales adaptables.',
  price: '$9.000 ARS'
}, {
  num: 3,
  title: 'Ficha Técnica de Diagnóstico Capilar',
  desc: 'Plantilla profesional para evaluar correctamente cada clienta.',
  price: '$7.000 ARS'
}, {
  num: 4,
  title: 'Calculadora Profesional de Mezclas',
  desc: 'Herramienta rápida para proporciones y formulaciones.',
  price: '$6.000 ARS'
}, {
  num: 5,
  title: 'Guía de Errores Comunes en Color',
  desc: 'Checklist de prevención y corrección técnica.',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'Protocolo Profesional de Consulta con Cliente',
  desc: 'Sistema para mejorar diagnóstico y percepción premium.',
  price: '$8.000 ARS'
}];
export function BonusSection() {
  return <section className="bg-brand-grayLight py-16 px-5 relative" data-id="element-36">
      <div className="max-w-xl mx-auto relative z-10" data-id="element-37">
        <div className="text-center mb-12" data-id="element-38">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4 leading-tight" data-id="element-39">
            🎁 RECIBÍS TAMBIÉN LOS{' '}
            <span className="text-brand-gold" data-id="element-40">6 BONOS</span> ESTRATÉGICOS
          </h2>
          <p className="text-xs text-slate-400 font-bold uppercase tracking-widest" data-id="element-41">
            Incluidos hoy sin costo adicional
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 mb-10" data-id="element-42">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white border border-slate-100 rounded-2xl p-6 relative overflow-hidden transition-all hover:shadow-lg hover:border-brand-gold/30" data-id="element-43">
              <div className="absolute top-4 right-4 bg-green-100 text-green-700 text-[10px] font-black px-3 py-1 rounded-full flex items-center gap-1" data-id="element-44">
                🎁 GRATIS
              </div>

              <div className="flex items-center gap-4 mb-4" data-id="element-45">
                <div className="bg-brand-gold/10 w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-46">
                  <span className="text-xl" data-id="element-47">🎁</span>
                </div>
                <span className="text-[11px] text-slate-400 font-bold uppercase tracking-wider" data-id="element-48">
                  BONO {bonus.num}
                </span>
              </div>

              <h3 className="text-lg font-black text-slate-900 mb-2 pr-20" data-id="element-49">
                {bonus.title}
              </h3>
              <p className="text-sm text-slate-500 mb-4 leading-relaxed" data-id="element-50">
                {bonus.desc}
              </p>

              <div className="flex items-center gap-3" data-id="element-51">
                <span className="text-sm text-slate-300 line-through font-medium" data-id="element-52">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-600 bg-green-50 px-2 py-0.5 rounded" data-id="element-53">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-white border-2 border-brand-gold/20 rounded-2xl p-8 text-center shadow-sm" data-id="element-54">
          <p className="text-slate-400 text-sm line-through mb-1 font-medium" data-id="element-55">
            Valor total bonos: +$45.000 ARS
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-gold" data-id="element-56">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-slate-400 mt-2 font-bold uppercase tracking-tighter" data-id="element-57">
            (solo por tiempo limitado)
          </p>
        </div>
      </div>
    </section>;
}